import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Form = styled.form`
  display: grid;
`;

export const Inputs = styled.div`
  padding: 0 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const SubmitButton = styled(Button)`
  margin-block: 15px;
  width: calc(100% - 30px);
  justify-self: center;
`;

export const ProfileNumber = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
`;
